import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { selectColor } from '@panel/commons';

const Collapsible = ({ formatedPrice, device }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const hasMany = formatedPrice.length > 1;

  return (
    <ContainerLayout device={device}>
      <div
        className='content'
        onMouseEnter={() => {
          if (hasMany) setOpen(true);
        }}
      >
        <CollapsibleItem key={formatedPrice[0].operationType} withTextDecoration={hasMany} device={device}>
          <div data-panel={`posting-priceInfo-${formatedPrice[0].operationType}`} className='operation'>
            {formatedPrice[0].operationType}
          </div>
          <div className='price'>
            <span data-panel={`posting-priceInfo-${formatedPrice[0].operationType}-price`}>
              {formatedPrice[0].price === 0 ? t('panel.posting.no.price') : formatedPrice[0].price}
            </span>
            {formatedPrice[0].secondPrice && (
              <span data-panel={`posting-priceInfo-${formatedPrice[0].operationType}-secondPrice`}>
                {`/ ${formatedPrice[0].secondPrice === 0 ? t('panel.posting.no.price') : formatedPrice[0].secondPrice}`}
              </span>
            )}
          </div>
        </CollapsibleItem>
      </div>
      {open && (
        <div
          className='list-container'
          onMouseLeave={() => {
            setOpen(false);
          }}
        >
          {formatedPrice.map((item, i) => {
            return (
              <ItemWrapper key={item.operationType}>
                <CollapsibleItem>
                  <div data-panel={`posting-priceInfo-${item.operationType}`} className='operation'>
                    {item.operationType}
                  </div>
                  <div className='price'>
                    <span data-panel={`posting-priceInfo-${item.operationType}-price`}>
                      {item.price === 0 ? t('panel.posting.no.price') : item.price}
                    </span>
                    {item.secondPrice && (
                      <span data-panel={`posting-priceInfo-${item.operationType}-secondPrice`}>{` / ${
                        item.secondPrice === 0 ? t('panel.posting.no.price') : item.secondPrice
                      }`}</span>
                    )}
                  </div>
                </CollapsibleItem>
                {i === 0 && <div className='divisor'>{t('panel.avisos.posting.price.others')}</div>}
              </ItemWrapper>
            );
          })}
        </div>
      )}
    </ContainerLayout>
  );
};

const ContainerLayout = styled.div`
  display: flex;
  position: relative;
  z-index: 1;
  .img-container {
    width: 16px;
    padding-left: 4px;
    padding-top: 2px;
    margin-right: 5px;
    img {
      margin-right: 8px;
      ${({ open }) =>
        open &&
        css`
          transform: rotate(90deg);
        `};
      transition: transform 0.3s;
    }
  }
  .label {
    color: ${selectColor('blue')};
    cursor: pointer;
    align-self: flex-end;
    height: inherit;
    margin-left: 12px;
  }
  .list-container {
    border-radius: 8px;
    background-color: white;
    position: absolute;
    left: -7px;
    top: -7px;
    padding: 6px;
    border: 1px solid ${selectColor('grayMediumLight')};
  }
  .content {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        max-width: 195px;
        overflow: hidden;
      `}
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .divisor {
    margin-bottom: 6px;
    color: ${selectColor('grayDark')};
    font-weight: 500;
  }
`;

const CollapsibleItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  .price {
    display: flex;
    align-items: flex-end;
    font-weight: 600;
    font-size: ${({ device }) => (device === 'tablet' ? 12 : 14)}px;
    ${({ withTextDecoration }) =>
      withTextDecoration &&
      css`
        text-decoration: underline;
      `}
    span:first-child {
      margin-right: 4px;
    }
  }
  .operation {
    font-size: 12px;
    color: ${selectColor('grayDark')};
    margin-right: 8px;
  }
`;

export default Collapsible;
